<div class="main-container">
  <!-- Component Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>

      @if (stateServerId === null) {
        <span class="page-title">Add Government Servers</span>
      }
      @if (stateServerId !== null) {
        <span class="page-title">View/Update Government Servers</span>
      }
    </div>
  </div>

  <!-- Component Body Section -->
  <div class="component-container">
    <form [formGroup]="addUpdateGovernmentServerStateForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">Government Servers Details</h6>
      </div>

      <div class="component-separator"></div>

      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <label for="state" class="form-label">State</label>
            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>
              <input
                placeholder="State"
                formControlName="state"
                matInput
                type="text"
                [readonly]="stateServerId !== null"
                required
              />

              @if (
                addUpdateGovernmentServerStateForm.controls['state'].touched &&
                addUpdateGovernmentServerStateForm.controls['state'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['state'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
              @if (
                addUpdateGovernmentServerStateForm.controls['state'].touched &&
                addUpdateGovernmentServerStateForm.controls['state'].errors
                  ?.nonNumericNoSpecialChars
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['state'].errors
                      ?.nonNumericNoSpecialChars
                  }}
                </mat-error>
              }
              @if (
                addUpdateGovernmentServerStateForm.controls['state'].touched &&
                addUpdateGovernmentServerStateForm.controls['state'].errors
                  ?.rangeLength
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['state'].errors
                      ?.rangeLength
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="stateCode" class="form-label">State Abbreviation</label>
            <mat-form-field appearance="outline">
              <mat-label>State Abbreviation</mat-label>
              <input
                placeholder="State Abbreviation"
                formControlName="stateCode"
                matInput
                type="text"
                required
                [readonly]="stateServerId !== null"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['stateCode']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['stateCode'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['stateCode']
                      .errors?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
              @if (
                addUpdateGovernmentServerStateForm.controls['stateCode']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['stateCode'].errors
                  ?.nonNumericNoSpecialChars
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['stateCode']
                      .errors?.nonNumericNoSpecialChars
                  }}
                </mat-error>
              }
              @if (
                addUpdateGovernmentServerStateForm.controls['stateCode']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['stateCode'].errors
                  ?.rangeLength
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['stateCode']
                      .errors?.rangeLength
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="govtIp1" class="form-label">Govt IP1</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt IP1</mat-label>
              <input
                placeholder="Govt. IP1"
                formControlName="govtIp1"
                matInput
                type="text"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['govtIp1']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['govtIp1'].errors
                  ?.maxLengthRequired
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['govtIp1']
                      .errors?.maxLengthRequired
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="port1" class="form-label">Port1</label>
            <mat-form-field appearance="outline">
              <mat-label>Port1</mat-label>
              <input
                placeholder="Port1"
                formControlName="port1"
                matInput
                type="text"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['port1'].touched &&
                addUpdateGovernmentServerStateForm.controls['port1'].errors
                  ?.portValidation
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['port1'].errors
                      ?.portValidation
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="govtIp2" class="form-label">Govt. IP2</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt. IP2</mat-label>
              <input
                placeholder="Govt. IP2"
                formControlName="govtIp2"
                matInput
                type="text"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['govtIp2']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['govtIp2'].errors
                  ?.maxLengthRequired
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['govtIp2']
                      .errors?.maxLengthRequired
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="port2" class="form-label">Port2</label>
            <mat-form-field appearance="outline">
              <mat-label>Port2</mat-label>
              <input
                placeholder="Port2"
                formControlName="port2"
                matInput
                type="text"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['port2'].touched &&
                addUpdateGovernmentServerStateForm.controls['port2'].errors
                  ?.portValidation
              ) {
                <mat-error>
                  {{
                    addUpdateGovernmentServerStateForm.controls['port2'].errors
                      ?.portValidation
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="stateEnable" class="form-label">State Enable</label>
            <mat-form-field appearance="outline">
              <mat-label>State Enable</mat-label>
              <input
                placeholder="State Enable Command"
                formControlName="stateEnable"
                matInput
                type="text"
              />
              @if (
                addUpdateGovernmentServerStateForm.controls['stateEnable']
                  .touched &&
                addUpdateGovernmentServerStateForm.controls['stateEnable']
                  .errors?.['pattern']
              ) {
                <mat-error> Please enter a valid State Enable. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="component-separator"></div>
      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        <div class="button-group">
          @if (stateServerId === null) {
            <button
              class="submit-button"
              (click)="submitGovtServers()"
              [disabled]="this.addUpdateGovernmentServerStateForm.invalid"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }

          @if (stateServerId !== null) {
            <button class="edit-button" (click)="updateGovtServers()">
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </form>
  </div>

  @if (stateServerId && firmwareDisplayIsList && projectName === 'LCT-A4G') {
    <div class="component-container">
      <!-- Component Header Section -->
      <form [formGroup]="a2tFirmwareSearchForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Open CPU Firmware List</h6>
          <div class="component-actions">
            <button class="primary-button" (click)="addNewFirmware('OC')">
              Add Open CPU Firmware <mat-icon class="btn-icon">add</mat-icon>
            </button>
            <!-- <app-common-component-dropdown-search [items]="firmwareStatusFilter" [initialValue]="this.currentA2TFilter"
            [placeHolder]="'Select Firmware Version'"
            (itemSelected)="getFilterA2TListByStatus($event)"></app-common-component-dropdown-search> -->
            <app-common-search
              [initialSearchValue]="
                a2tFirmwareSearchForm?.get('searchValue')?.value
              "
              (searchSubmit)="onSearchOpenCPUInputChange($event)"
            ></app-common-search>
          </div>
        </div>
      </form>
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Firmware Type</th>
              <th>Firmware Version</th>
              <th>Upload File / File Name</th>
              <!-- <th>File Name</th> -->
              <th>Description</th>
              <th>Release Date</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (displayedA2TItems.length > 0) {
            <tbody>
              @for (item of displayedA2TItems; track item) {
                <tr>
                  <td>
                    {{ item.firmwareType === 'D' ? 'Device' : 'Open CPU' }}
                  </td>
                  <td>{{ item.firmwareName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.releaseDate | date: 'yyyy-MM-dd' }}</td>
                  <td>
                    <div class="action-buttons">
                      <button
                        class="primary-button delete-button"
                        (click)="deleteFirmwareFile(item, 'OC')"
                      >
                        <mat-icon class="btn-icon">delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (displayedA2TItems.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    </div>
  }

  <!-- Firmware List Section -->
  @if (stateServerId && firmwareDisplayIsList) {
    <div class="component-container">
      <!-- Component Header Section -->
      <form [formGroup]="firmwareSearchForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Device Firmware List</h6>
          <div class="component-actions">
            <button class="primary-button" (click)="addNewFirmware('D')">
              Add Device Firmware <mat-icon class="btn-icon">add</mat-icon>
            </button>
            <!-- <app-common-component-dropdown-search [items]="firmwareStatusFilter" [initialValue]="this.currentFilter"
            [placeHolder]="'Select Firmware Version'"
            (itemSelected)="getFilterListByStatus($event)"></app-common-component-dropdown-search> -->
            <app-common-search
              [initialSearchValue]="
                firmwareSearchForm?.get('searchValue')?.value
              "
              (searchSubmit)="onSearchInputChange($event)"
            ></app-common-search>
          </div>
        </div>
      </form>
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Firmware Type</th>
              <th>Firmware Version</th>
              <th>Upload File / File Name</th>
              <!-- <th>File Name</th> -->
              <th>Description</th>
              <th>Release Date</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (displayedItems.length > 0) {
            <tbody>
              @for (item of displayedItems; track item) {
                <tr>
                  <td>
                    {{ item.firmwareType === 'D' ? 'Device' : 'Open CPU' }}
                  </td>
                  <td>{{ item.firmwareName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.releaseDate | date: 'yyyy-MM-dd' }}</td>
                  <td>
                    <div class="action-buttons">
                      <button
                        class="primary-button delete-button"
                        (click)="deleteFirmwareFile(item, 'D')"
                      >
                        <mat-icon class="btn-icon">delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (displayedItems.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    </div>
  }

  @if (stateServerId && !firmwareDisplayIsList) {
    <div class="component-container">
      <!-- Component Header Section -->
      <!-- <form [formGroup]="firmwareSearchForm" novalidate> -->
      <div class="component-header">
        <h6 class="component-title">Firmware Master List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="firmwareSearchForm?.get('searchValue')?.value"
            (searchSubmit)="onSearchFirmwareListInputChange($event)"
          ></app-common-search>
          <div class="component-actions">
            <button class="primary-button" (click)="addNewFirmware('')">
              <mat-icon class="btn-icon">close</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <!-- </form> -->
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>Firmware Type</th>
              <th>Firmware Version</th>
              <th>Upload File / File Name</th>
              <th>Description</th>
              <th>Release Date</th>
              <th>Created By</th>
            </tr>
          </thead>
          @if (FirmwareMasterList.length > 0) {
            <tbody>
              @for (item of FirmwareMasterList; track item) {
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      (change)="onRowCheckboxChange($event, item.id)"
                    />
                  </td>
                  <td>
                    {{ item.firmwareType === 'D' ? 'Device' : 'Open CPU' }}
                  </td>
                  <td>{{ item.firmwareName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.releaseDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ item.createdBy }}</td>
                </tr>
              }
            </tbody>
          }
          @if (FirmwareMasterList.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-footer">
        <div class="button-group">
          @if (firmwareFormType === 'Add' && selectedFirmwareIds.length > 0) {
            <button
              class="submit-button"
              (click)="submitGovtServerFirmwareDetails()"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
